import IconBBVA from '../assets/bank_icons/bbva_icon_bank.svg';
import IconInterbank from '../assets/bank_icons/interbank_icon_bank.svg';
import IconScotia from '../assets/bank_icons/scotia_icon_bank.svg';
import IconBCP from '../assets/bank_icons/bcp_icon_bank.svg';
import IconOther from '../assets/bank_icons/other_icon_bank.svg';

const bankList = [
  {
    text: 'BBVA',
    value: 'BBVA',
    payloadValue: 'BANCO CONTINENTAL',
    type: 'initial',
    logo: IconBBVA,
  },
  {
    text: 'Interbank',
    value: 'INT',
    payloadValue: 'INTERBANK',
    type: 'initial',
    logo: IconInterbank,
  },
  {
    text: 'Scotiabank',
    value: 'SCT',
    payloadValue: 'SCOTIABANK',
    type: 'initial',
    logo: IconScotia,
  },
  {
    text: 'BCP',
    value: 'BCP',
    payloadValue: 'BANCO DE CREDITO DEL PERU',
    type: 'initial',
    logo: IconBCP,
  },
  {
    text: 'Citibank del Perú S.A',
    value: 'CITY',
    payloadValue: 'CITIBANK DEL PERU',
    type: 'other',
    logo: IconOther,
  },
  {
    text: 'Banco de la Nación',
    value: 'BN',
    payloadValue: 'BANCO DE LA NACION',
    type: 'other',
    logo: IconOther,
  },
  {
    text: 'Banco de Comercio',
    value: 'BC',
    payloadValue: 'BANCO DE COMERCIO',
    type: 'other',
    logo: IconOther,
  },
  {
    text: 'Banco Financiero del Perú - Pichincha',
    value: 'PCH',
    payloadValue: 'PICHINCHA',
    type: 'other',
    logo: IconOther,
  },
  {
    text: 'Banco Interamericano de Finanzas (BANBIF)',
    value: 'BNBF',
    payloadValue: 'BANBIF',
    type: 'other',
    logo: IconOther,
  },
  {
    text: 'Banco GNB Perú S.A.',
    value: 'GNB',
    payloadValue: 'BANCO GNB',
    type: 'other',
    logo: IconOther,
  },
  {
    text: 'Caja Municipal de Ahorro y Crédito Trujillo',
    value: 'CMT',
    payloadValue: 'CAJA TRUJILLO',
    type: 'other',
    logo: IconOther,
  },
  {
    text: 'Caja Municipal de Ahorro y Crédito Arequipa',
    value: 'CMA',
    payloadValue: 'CAJA AREQUIPA',
    type: 'other',
    logo: IconOther,
  },
  {
    text: 'Caja Municipal de Ahorro y Crédito Sullana',
    value: 'CMS',
    payloadValue: 'CAJA SULLANA',
    type: 'other',
    logo: IconOther,
  },
  {
    text: 'Caja Municipal de Ahorro y Crédito Huancayo',
    value: 'CMH',
    payloadValue: 'CAJA HUANCAYO',
    type: 'other',
    logo: IconOther,
  },
];

const accountList = [
  {
    text: 'Cuenta de ahorro',
    value: 'Ahorro',
  },
  {
    text: 'Cuenta corriente',
    value: 'Corriente',
  },
];
const accountListNewPT = [
  {
    text: 'Cuenta de ahorro',
    value: 'Ahorro',
  }
];

export { bankList, accountList, accountListNewPT };
